const styles = (theme) => ({
  root: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    backgroundColor: theme.color.black,
  },
  rootFixed: {
    position: 'fixed',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    maxWidth: theme.breakpoints.values.sm,
    zIndex: 1000,
  },
  closeBtn: {
    position: 'absolute',
    top: theme.spacing(1.5),
    left: theme.spacing(1),
    zIndex: 1000,
  },
});

export default styles;
